export var defaultProps = {
    className: '',
    hasSider: false,
};
export var defaultSiderProps = {
    className: '',
    width: 200,
};
export var defaultHeaderProps = {
    className: '',
};
export var defaultContentProps = {
    className: '',
};
export var defaultFooterProps = {
    className: '',
};
